'use es6';

import { createSelector } from 'reselect';
import { getAreFilesBeingReplaced } from './Files';
export const getUploadingFiles = state => {
  return state.uploadingFiles.get('files');
};
export const getAreFilesUploading = createSelector([getUploadingFiles, getAreFilesBeingReplaced], (uploadingFiles, areFilesBeingReplaced) => {
  return !uploadingFiles.isEmpty() || areFilesBeingReplaced;
});